<template>
  <div
    class="step-button"
    :class="[
      { 'step-button--active': currentStep === props.name },
    ]"
    v-if="show"
  >
    <div
      class="step-button__container"
      :class="[
        { 'step-button__container--active': currentStep === props.name },
      ]"  
    >
      <button
        class="step-button__button"
        :class="[
          { 'step-button__button--active': currentStep === props.name },
        ]"
        @click="handleClick"
        :disabled="disabled"
      >
        <slot></slot>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import pinia from '../../core/pinia';
import { useStepsStore } from '../../stores';
import { E_STEP_BUTTON_EVENT } from '../../types/components-events.enums';
import type { TStepButtonEventResponse } from '../../types/event-response.types';
import emitter from '../../core/emitter';
import { E_MIDDLEWARE_STEPS } from '../../types/middlewares.types';

interface IProps {
  name: string;
  show: boolean;
  disabled?: boolean;
}
const props = defineProps<IProps>();
const emit = defineEmits<{
  (e: E_STEP_BUTTON_EVENT.CLICK, payload: TStepButtonEventResponse[E_STEP_BUTTON_EVENT.CLICK]): TStepButtonEventResponse;
}>();

const stepsStore = useStepsStore(pinia);

const currentStep = computed(() => stepsStore.getCurrentStep);

function handleClick() {
  emitter.emit(E_MIDDLEWARE_STEPS.CHANGE, props.name);
  emit(E_STEP_BUTTON_EVENT.CLICK, props.name);
}
</script>

<style scoped lang="scss">
.step-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &__container {
    padding: 14px 0 12px 0;
    margin-bottom: 2px;
  }
  
  &__button {
    font-family: 'Montserrat';
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    color: #686868;
    background: none;
    border: none;
    cursor: pointer;
  }

  &__button--active {
    color: #282828;
  }

  &__container--active {
    border-bottom: 2px solid $second-brand-color;
    margin-bottom: 0px;
  }
}
</style>